// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/Thicker-Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: lightThicker;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.page-head {
  padding-top: 85px;
  width: 100%;
  background-color: #fff !important;
}

.page-text {
  max-width: 100%;
  /* display: flex;
    align-items: center;
    justify-content: center; */
  padding: 0 5vw;
}

.page-name {
  color: #ba1e24;
  font-family: Thicker;
  font-size: clamp(20px, 5vw, 54px);
  font-style: normal;
  font-weight: 400;
  line-height: 126.6%;
  text-transform: uppercase;
  margin: 35px 0 0 0;
}

.page-heading {
  display: none;
  color: #000;
  font-family: Thicker;
  font-size: clamp(16px, 5vw, 24px);

  font-style: normal;
  font-weight: 600;
  line-height: 126.6%;
  text-transform: capitalize;
}

.photos_text_p3 {
  color: #000;
  font-family: Thicker;
  font-size: 54px;
  font-style: normal;
  font-weight: 600;
  line-height: 126.6%;
  text-transform: capitalize;
}

.page-content {
  color: #000;
  font-family: "lightThicker";
  font-size: clamp(14px, 2vw, 20px);
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin: 20px 0 45px 0;
}

.page-banner {
  width: 100%;
  flex-shrink: 0;
}

.page-banner > img {
  width: 100%;
}

/* VIDEO STYLING*/

.page-video {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}

.page-video-tag {
  margin-top: 60px;
  width: 100%;
  object-fit: cover;
}

.video-btn {
  border: none;
  position: absolute;
  z-index: 2;
  bottom: 4%;
  right: 2%;
  background: none;
}
@media screen and (max-width: 600px) {
  .page-content {
    margin: 20px 0 10px 0;
  }

  .page-name {
    margin: 20px 0 0 0;
  }
  .page-heading {
    margin: 10px 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/pageHead/pageHead.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4CAAmD;AACrD;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf;;8BAE4B;EAC5B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,iCAAiC;;EAEjC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,iBAAiB;;AAEjB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["@font-face {\n  font-family: lightThicker;\n  src: url(../../../assets/fonts/Thicker-Regular.otf);\n}\n\n.page-head {\n  padding-top: 85px;\n  width: 100%;\n  background-color: #fff !important;\n}\n\n.page-text {\n  max-width: 100%;\n  /* display: flex;\n    align-items: center;\n    justify-content: center; */\n  padding: 0 5vw;\n}\n\n.page-name {\n  color: #ba1e24;\n  font-family: Thicker;\n  font-size: clamp(20px, 5vw, 54px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 126.6%;\n  text-transform: uppercase;\n  margin: 35px 0 0 0;\n}\n\n.page-heading {\n  display: none;\n  color: #000;\n  font-family: Thicker;\n  font-size: clamp(16px, 5vw, 24px);\n\n  font-style: normal;\n  font-weight: 600;\n  line-height: 126.6%;\n  text-transform: capitalize;\n}\n\n.photos_text_p3 {\n  color: #000;\n  font-family: Thicker;\n  font-size: 54px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 126.6%;\n  text-transform: capitalize;\n}\n\n.page-content {\n  color: #000;\n  font-family: \"lightThicker\";\n  font-size: clamp(14px, 2vw, 20px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  margin: 20px 0 45px 0;\n}\n\n.page-banner {\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.page-banner > img {\n  width: 100%;\n}\n\n/* VIDEO STYLING*/\n\n.page-video {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.page-video-tag {\n  margin-top: 60px;\n  width: 100%;\n  object-fit: cover;\n}\n\n.video-btn {\n  border: none;\n  position: absolute;\n  z-index: 2;\n  bottom: 4%;\n  right: 2%;\n  background: none;\n}\n@media screen and (max-width: 600px) {\n  .page-content {\n    margin: 20px 0 10px 0;\n  }\n\n  .page-name {\n    margin: 20px 0 0 0;\n  }\n  .page-heading {\n    margin: 10px 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
